import _ from 'lodash';
import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { PropTypes } from '~/utils';
import { useDebug } from '~/hooks';
import { reducer, useDispatchers } from './reducer';
import { useAuthHandler } from './auth';
import { useSwipesHandler } from './swipes';

export * from './config';
export * from './info';

export const GlobalContext = createContext( {} );
const defaultState = {
  config  : {},
};

const { Provider } = GlobalContext;
export function GlobalContextProvider( { children } ) {
  const [ state, dispatch ] = useReducer( reducer, defaultState );

  useDebug( 'GlobalContext', state );

  const { authenticate } = useAuthHandler( state, dispatch );
  useDispatchers( state, dispatch );
  useSwipesHandler( state, dispatch );

  const value = useMemo( () => {
    return _.assign( {}, state, { dispatch, authenticate } );
  }, [ state, dispatch, authenticate ] );

  return ( <Provider value={value}>{children}</Provider> );
}
GlobalContextProvider.propTypes = { children : PropTypes.node };

export function useGlobalContext() { return useContext( GlobalContext ); }
